import { atom, createStore, getDefaultStore } from 'jotai';
import { resetUploadQueue } from './library-upload/helpers/resetUploadQueue';

// Provider store: handed to <JotaiProvider> and replaced on reset(). Everything inside the
// provider is wiped on a session boundary.
let resettableStore = createStore();

// Global store: Jotai's default store, lives above the provider; reset() never replaces it, so
// state kept here (storeKey, the auth session core) survives a session boundary.
const globalStore = getDefaultStore();
const storeKey = atom(0);

const reset = () => {
  // The upload queue keeps state outside the provider store (imperative handles, per-item
  // atom cache), so it needs an explicit teardown rather than just a fresh store.
  resetUploadQueue();
  globalStore.set(storeKey, (p) => p + 1);
  resettableStore = createStore();
};

export { globalStore, reset, resettableStore as store, storeKey };
